export default {
  value: {
    type: Number,
    default: -1,
  },
  variant: {
    type: String,
  },
  isInteractive: {
    type: Boolean,
    default: false,
  },
  hasAlert: {
    type: Boolean,
    default: false,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
}
